import { createContext, useContext, useEffect } from 'react'

/** Takes a lock on the sheet's dismissal; the return releases it. */
export type AcquireDismissLock = () => () => void

// No provider above means no sheet to lock — a screen rendered bare (tests,
// Storybook) asks for nothing.
const FlowDismissLockContext = createContext<AcquireDismissLock>(
  () => () => undefined,
)

export const FlowDismissLockProvider = FlowDismissLockContext.Provider

/**
 * Holds the flow sheet closed to swipes and backdrop taps while `locked`.
 *
 * A step at the root of the flow stack is dismissable by design, but a step
 * can carry screens of its own — the fiat rail's contact, code and identity
 * screens all render inside the amount step. Those are screens the user is
 * part-way through, and the only way off them is their own back control.
 */
export function useLockFlowDismiss(locked: boolean): void {
  const acquire = useContext(FlowDismissLockContext)
  useEffect(() => (locked ? acquire() : undefined), [locked, acquire])
}
